import axios from 'axios'


export default {
    name: 'checkoutAPI',
    getInstallments(value) {
        return axios.get('/api/v1/checkout/getinstallments?value='+value)
    },
    createOrder(orderForm, successCallback, errorCallback) {
        console.log('creating order');
        axios.post('/api/v1/checkout/createorder', orderForm)
            .then(response => {
                console.log(response);
                successCallback();
            })
            .catch(error => {
                console.log(error);
                try { axios.get('/api/v1/checkout/logerror?email=' + orderForm.clientProfileData.email + '&log=' + error); }
                catch { console.log('') }
                errorCallback();
            })
            .finally(() => console.log('end'))
    }
}